var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_2283)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_77_2283",
    style: {
      "maskType": "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9947 0.923828H0.00531006V27.9132H26.9947V0.923828Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_77_2283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2828 11.4928C23.5077 12.3924 23.6202 13.4045 23.6202 14.4166C23.6202 20.6017 18.5596 25.6622 12.3746 25.6622C6.18948 25.6622 1.12897 20.6017 1.12897 14.4166C1.12897 8.23153 6.18948 3.17102 12.3746 3.17102C14.5112 3.17102 16.5354 3.7333 18.3347 4.85786",
    stroke: "white",
    strokeWidth: 2.34691,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87634 12.1694L12.3746 16.6677L24.7447 4.29749",
    stroke: "white",
    strokeWidth: 2.34691,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_2283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.9894,
    height: 26.9894,
    fill: "white",
    transform: "translate(0.00531006 0.923828)"
  })))));
};
export default __webpack_public_path__ + "static/media/LightChecked.e1741fc7.svg";
export { SvgComponent as ReactComponent };